import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions/index";
import sampleCombine from 'xstream/extra/sampleCombine';
import { push } from 'react-router-redux'
import {reset} from "redux-form/immutable";

export function resetPillarFormAfterCreate(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_PILLAR_SUCCESS)
    .map(action => reset('pillar'));

  return {
    ACTION: action$,
  }
}


export function redirectAfterPillarDelete(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_PILLAR_SUCCESS)
    .map(action => (push('/pillars')));

  return {
    ACTION: action$
  }
}

export function requestDeletePillar(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_PILLAR)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/pillars/' + action.payload.id,
      category: 'requestDeletePillar',
      method: 'DELETE',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestDeletePillar')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => actions.deletePillarSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestDeletePillarFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestDeletePillar')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 204)
    .map(response => actions.deletePillarFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function redirectAfterUpdatePillarSuccess(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_PILLAR_SUCCESS)
    .map(action => push('/pillars'));

  return {
    ACTION: action$,
  }
}

export function requestUpdatePillar(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_PILLAR)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/pillars/' + action.payload.id,
      category: 'requestUpdatePillar',
      method: 'PATCH',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestUpdatePillar')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.updatePillarSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestUpdatePillarFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestUpdatePillar')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.updatePillarFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestPillarById(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_PILLAR_BY_ID)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/pillars/' + action.payload.id,
      category: 'requestPillarById',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestPillarById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getPillarByIdSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestPillarByIdFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestPillarById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getPillarByIdFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCreatePillar(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_PILLAR)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/pillars',
      category: 'requestCreatePillar',
      method: 'POST',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCreatePillar')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.createPillarSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCreatePillarFail(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCreatePillar')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.createPillarFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/pillar.js